/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Loud_Free_Bee_LeadInputs */

const en_loud_free_bee_lead = /** @type {(inputs: Loud_Free_Bee_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The assigned managers can manage ${i?.displayName}.`)
};

const de_loud_free_bee_lead = /** @type {(inputs: Loud_Free_Bee_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die zugewiesenen Manager können ${i?.displayName} verwalten.`)
};

/**
* | output |
* | --- |
* | "The assigned managers can manage {displayName}." |
*
* @param {Loud_Free_Bee_LeadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const loud_free_bee_lead = /** @type {((inputs: Loud_Free_Bee_LeadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_Free_Bee_LeadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loud_free_bee_lead(inputs)
	return de_loud_free_bee_lead(inputs)
});